import Model, { attr } from '@ember-data/model';

export default class YtdGivenExpectedReportModel extends Model {
  @attr('number') annualGoal?: number;
  @attr('date-only') startAt?: Date;
  @attr() ytdData?: any;
}

declare module 'ember-data/types/registries/model' {
  export default interface ModelRegistry {
    'ytd-given-expected-report': YtdGivenExpectedReportModel;
  }
}
